export const docType = {
  CONTRACT: "CONTRACT",
  CONTRACTDRAFT: "CONTRACT",
  DOCUMENTS: "DOCUMENT",
  CONTRACT_DOCUMENTS: "DOCUMENT",
  PLANS: "PLAN",
  LINKS: "LINK",
  SIGN_CONTRACT_DATA_FILES_CONTRACTS_COLUMN_TITLE: "SIGN_CONTRACT_FILES_CONTRACT",
  SIGN_CONTRACT_DATA_FILES_DOCUMENTS_COLUMN_TITLE: "SIGN_CONTRACT_FILES_DOCUMENT",
  SIGN_CONTRACT_DATA_FILES_PLANS_COLUMN_TITLE: "SIGN_CONTRACT_FILES_PLAN",
};

export const docLabel = {
  CONTRACT: "contracts",
  CONTRACTDRAFT: "contracts",
  DOCUMENTS: "documents",
  CONTRACT_DOCUMENTS: "documents",
  PLANS: "plans",
  LINKS: "links",
  SIGN_CONTRACT_DATA_FILES_CONTRACTS_COLUMN_TITLE: "contracts",
  SIGN_CONTRACT_DATA_FILES_DOCUMENTS_COLUMN_TITLE: "documents",
  SIGN_CONTRACT_DATA_FILES_PLANS_COLUMN_TITLE: "plans",
};

export const fileExtension = {
  PNG: "PNG",
  JPG: "JPG",
  ZIP: "ZIP",
  PDF: "PDF",
  XLS: "XLS",
  XLSX: "XLSX",
  DOC: "DOC",
  DOCX: "DOCX",
  CSV: "CSV",
  MSG: "MSG",
  EML: "EML",
  STREAM: "STREAM",
};

export const fileType = {
  [fileExtension.PNG]: "image/png",
  [fileExtension.JPG]: "image/jpeg",
  [fileExtension.ZIP]: "application/zip",
  [fileExtension.PDF]: "application/pdf",
  [fileExtension.XLS]: "application/vnd.ms-excel",
  [fileExtension.XLSX]:
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  [fileExtension.DOC]: "application/msword",
  [fileExtension.DOCX]:
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  [fileExtension.CSV]: "text/csv;charset=utf-8;",
  [fileExtension.STREAM]: "application/octet-stream",
  [fileExtension.MSG]: "application/vnd.ms-outlook",
  [fileExtension.EML]: "message/rfc822",
};

const alternativeFileTypes = {
  [fileExtension.JPG]: ["image/jpg", "image/pjpeg"],
  [fileExtension.PNG]: ["image/x-png"],
  [fileExtension.ZIP]: [
    "application/x-zip-compressed",
    "application/x-zip",
    "multipart/x-zip",
  ],
  [fileExtension.PDF]: ["application/x-pdf"],
  [fileExtension.MSG]: ["application/x-msg", "application/msg"],
};

export const fileExtensionFromType = Object.fromEntries([
  ...Object.entries(fileType)
    .filter(([ext]) => ext !== fileExtension.STREAM)
    .map(([ext, mime]) => [mime, ext]),
  ...Object.entries(alternativeFileTypes).flatMap(([ext, mimeTypes]) =>
    mimeTypes.map((mime) => [mime, ext])
  ),
]);

export const commonFileExtensions = [
  fileExtension.PNG,
  fileExtension.ZIP,
  fileExtension.JPG,
  fileExtension.PDF,
  fileExtension.XLS,
  fileExtension.XLSX,
  fileExtension.DOC,
  fileExtension.DOCX,
];
